import { useAppState } from '@zenos/front-end-context';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { PageLoader } from '../../../../../ui/page/src/lib/components/PageLoader';
import useZenOSAbility from '../hooks/useZenOSAbility';

interface AbilityGuardProps {
  action: string;
  subject: string;
  fallbackPath?: string;
}

export const AbilityGuard: React.FC<AbilityGuardProps> = ({
  action,
  subject,
  fallbackPath = '/403',
}) => {
  const ability = useZenOSAbility();
  const canAccess = ability.can(action, subject);
  const {
    state: { isLoadingPermissions },
  } = useAppState();

  if (isLoadingPermissions) {
    return <PageLoader />;
  }

  if (!canAccess) {
    console.warn(`Access denied for ${action} ${subject}`);
    return <Navigate to={fallbackPath} replace />;
  }

  return <Outlet />;
};
